/**
 * 规则指纹
 * 规则最高优先级, 权重区间100000 - 90001, 步长100
 */
import * as Mathchers from './mathchers'

export default function Mathcher(R){

	return [
		{
			// 将MehodId匹配一个规则指纹
			priority: 100000,
			condition: function(R) {
		        R.when( !this.token && this.lotteryType === 'ssc');
		    },
		    consequence: function(R) {
				if(!this.currentMethod) return;
				this.token = Mathchers.method2Token(this.mathcherName);        
		        R.next();
		    }
		},
		{
			// 没有找到玩法对应的规则指纹
			priority: 99900,
			condition: function(R) {
		        R.when( _.isUndefined(this.token) && this.lotteryType === 'ssc');
		    },
		    consequence: function(R) {
		    	this.message.push('没有找到玩法对应的规则指纹')
		        R.next();
		    }			
		},
		{
			// 将规则指纹匹配一个规则set
			priority: 99800,
			condition: function(R) {
		        R.when( !this.ruleSuite && this.lotteryType === 'ssc' );
		    },
		    consequence: function(R) {
				this.ruleSuite = Mathchers.token2Rules(this.token);        
		        R.next();
		    }
		},
		{
			// 将规则指纹匹配一个规则set
			priority: 99700,
			condition: function(R) {
		        R.when( _.isUndefined(this.ruleSuite) && this.lotteryType === 'ssc');
		    },
		    consequence: function(R) {
		    	this.message.push('没有找到规则指纹对应的规则集合');
		        R.next();
		    }
		},
		{
			// 六合彩对应规则
			priority: 99600,
			condition: function(R) {
		        R.when( this.lotteryType === 'lhc');
		    },
		    consequence: function(R) {
				this.ruleSuite = Mathchers.mathLhcRules(this.currentMethod.lotteryId)
		        R.next();
		    }
		}

	]

}